/* unplugin-vue-components disabled */const { computed } = require('vue');
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-82d65e14"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { id: "items-wrap" };
const _hoisted_2 = { class: "coord-name" };
const _hoisted_3 = { class: "point-name" };
const index_vue_1 = tslib_1.__importDefault(require("@/components/SensitiveInput/index.vue"));
const index_vue_2 = tslib_1.__importDefault(require("@/components/DeleteBtn/index.vue"));
const model_1 = require("@/model");
const one_message_1 = require("@/utils/one_message");
const work_1 = require("@/store/modules/work");
exports.default = (0, vue_1.defineComponent)({
    __name: 'CoordPanel',
    setup(__props, { expose: __expose }) {
        const workStore = (0, work_1.useWork)();
        const curRobot = computed(() => (model_1.Project.current().curProgram.robot));
        const rpList = computed(() => { var _a; return ((_a = curRobot.value) === null || _a === void 0 ? void 0 : _a.tcps.filter(tcp => tcp.reference.frame === 'rp')) || []; });
        const handleNewCoord = () => {
            let rp = model_1.Project.current().createRp();
            curRobot.value.addTcp(rp, model_1.DEVICE_TYPE_NAME.RP);
        };
        const onDel = (rp) => {
            curRobot.value.delTcp(rp.id);
            workStore.notifyDeleteUcs(rp);
        };
        function onNameBeforeChange(name) {
            let patrn = /[`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/im;
            if (patrn.test(name)) {
                (0, one_message_1.oneMessage)({ message: '名称不能含有特殊字符，请重新修改！', type: 'error' });
                return false;
            }
            if (name.indexOf(' ') !== -1) {
                (0, one_message_1.oneMessage)({ message: '名称不能含有空格，请重新修改！', type: 'error' });
                return false;
            }
            return true;
        }
        const onUcsChange = (name) => {
            let tcp = curRobot.value.tcps.find(tcp => tcp.name === name);
            if (tcp) {
                (0, one_message_1.oneMessage)({ message: '名称重复，请重新修改！', type: 'error' });
            }
            return !tcp;
        };
        const onRPointChange = (name, points, curPointName) => {
            let rpPointNames = ["R1", "R2", "R3"].filter(name => name != curPointName);
            for (let i = 0; i < rpPointNames.length; i++) {
                console.log('points[rpPointNames[i]]', points[rpPointNames[i]]);
                if (points[rpPointNames[i]].name === name) {
                    (0, one_message_1.oneMessage)({ message: '名称重复，请重新修改！', type: 'error' });
                    return false;
                }
            }
            return true;
        };
        const handleRpNameChange = (rp) => {
            workStore.notifyChangeUcs(rp);
        };
        __expose({
            handleNewCoord
        });
        return (_ctx, _cache) => {
            const _component_el_form_item = (0, vue_2.resolveComponent)("el-form-item");
            const _component_el_form = (0, vue_2.resolveComponent)("el-form");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(rpList), (rp) => {
                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                        key: `rp${rp.id}`
                    }, [
                        (0, vue_2.createElementVNode)("div", _hoisted_2, [
                            (0, vue_2.createVNode)(index_vue_1.default, {
                                model: rp.name,
                                "onUpdate:model": ($event) => ((rp.name) = $event),
                                beforeChange: (name) => onNameBeforeChange(name) && onUcsChange(name),
                                maxlength: "15",
                                onOnChange: ($event) => (handleRpNameChange(rp))
                            }, null, 8, ["model", "onUpdate:model", "beforeChange", "onOnChange"]),
                            (0, vue_2.createVNode)(index_vue_2.default, {
                                title: `确定需要删除${rp.name}吗？`,
                                onDelConfirm: ($event) => (onDel(rp))
                            }, null, 8, ["title", "onDelConfirm"])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_3, [
                            (0, vue_2.createVNode)(_component_el_form, { "label-width": "100" }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createVNode)(_component_el_form_item, { label: "坐标系原点" }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createVNode)(index_vue_1.default, {
                                                model: rp.refPoints.R1.name,
                                                "onUpdate:model": ($event) => ((rp.refPoints.R1.name) = $event),
                                                beforeChange: (name) => onNameBeforeChange(name) && onRPointChange(name, rp.refPoints, 'R1'),
                                                maxlength: "15"
                                            }, null, 8, ["model", "onUpdate:model", "beforeChange"])
                                        ]),
                                        _: 2
                                    }, 1024),
                                    (0, vue_2.createVNode)(_component_el_form_item, { label: "X轴正方向点" }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createVNode)(index_vue_1.default, {
                                                model: rp.refPoints.R2.name,
                                                "onUpdate:model": ($event) => ((rp.refPoints.R2.name) = $event),
                                                beforeChange: (name) => onNameBeforeChange(name) && onRPointChange(name, rp.refPoints, 'R2'),
                                                maxlength: "15"
                                            }, null, 8, ["model", "onUpdate:model", "beforeChange"])
                                        ]),
                                        _: 2
                                    }, 1024),
                                    (0, vue_2.createVNode)(_component_el_form_item, { label: "XY平面上的点" }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createVNode)(index_vue_1.default, {
                                                model: rp.refPoints.R3.name,
                                                "onUpdate:model": ($event) => ((rp.refPoints.R3.name) = $event),
                                                beforeChange: (name) => onNameBeforeChange(name) && onRPointChange(name, rp.refPoints, 'R3'),
                                                maxlength: "15"
                                            }, null, 8, ["model", "onUpdate:model", "beforeChange"])
                                        ]),
                                        _: 2
                                    }, 1024)
                                ]),
                                _: 2
                            }, 1024),
                            (0, vue_2.createVNode)(index_vue_2.default, {
                                title: "",
                                unvisibility: true
                            })
                        ])
                    ]));
                }), 128))
            ]));
        };
    }
});
